import {RouteRecordRaw} from "vue-router";
import Easy from "@/router/modules/my/easy";

const My: RouteRecordRaw[] = [
    ...Easy,
]

export default My
